import classNames from 'classnames';
import { Component, type JSX } from 'react';

import { DaysRangeData, MoneyData } from '../../../data/model';
import { ShoppingCartSummaryTranslation } from '../../../localization/SiteTranslation';
import Price from '../../../shared/components/Price';
import TextInfo from '../../../shared/components/TextInfo/TextInfo';
import { createDeliveredWithinText } from './createDeliveryTimeText';
import css from './DeliveryFee.css';

interface DeliveryFeeProps {
  className?: string;
  deliveryTimeClassName?: string;
  translation: ShoppingCartSummaryTranslation;
  shippingTotal: MoneyData;
  shippingCostAvailable: boolean;
  deliveryTime?: DaysRangeData;
}

export const FeeRow = ({ text, value }: { text: string; value: JSX.Element | string }) => {
  return (
    <p className={classNames(css.FeeRow)}>
      <span className={css.text}>{text}</span>
      <span className={css.fee}>{value}</span>
    </p>
  );
};

export class DeliveryFee extends Component<DeliveryFeeProps, {}> {
  render() {
    const { translation, shippingTotal, className, deliveryTimeClassName, shippingCostAvailable, deliveryTime } =
      this.props;
    const freeDelivery = shippingTotal.amount === 0;
    const deliveredWithinText = createDeliveredWithinText(deliveryTime, translation.shippingTimeText);

    return (
      <div className={classNames(css.DeliveryFee, className)}>
        <FeeRow
          text={translation.deliveryFee}
          value={
            shippingCostAvailable ? (
              freeDelivery ? (
                translation.freeDeliveryText
              ) : (
                <Price price={shippingTotal} />
              )
            ) : (
              translation.deliveryCostUnavailable
            )
          }
        />
        {deliveredWithinText && (
          <TextInfo className={classNames(css.deliveryTime, deliveryTimeClassName)}>{deliveredWithinText}</TextInfo>
        )}
      </div>
    );
  }
}
